import { create } from "zustand";

const useMoreMenuModal = create((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useMoreMenuModal;
